import React, { useEffect, useState, } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Paggination/Paggination";
import Select from "../../components/Select/";
import { getTracks } from "../../redux/actions/track";
import getDate from "../../helpers/getDate";
import { m } from "framer-motion";

const sortOtions = [
    { id: "updatedAt", value: "За датою редагування" },
    { id: "title", value: "За абеткою" },
  ];

const TrackLibraryPage = ()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [modal, setModal] = useState(false);
    const { track } = useSelector((state) => state);
    const [intervalId,setIntervalId] = useState(null);  const [ready, setReady] = useState(false);
    const [sortData, setSortData] = useState("updatedAt");
    const [sortName, setSortName] = useState("За датою редагування");
    const [sortValue, setSortValue] = useState("desc");
    const { listId } = useSelector((state) => state);
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState(false);
    const [filterArr, setFilterArr] = useState({});

    const searchChange = (e) => {
        let filter = {};
        setSearchValue(e.target.value);
        if (localStorage.getItem("trackFilter")) {
          filter = JSON.parse(localStorage.getItem("trackFilter"));
        }
        filter.all = [];
          clearTimeout(intervalId);
          const newIntervalId = setTimeout(() =>{
          // Call your search function with the updated query value
        
          if (e.target.value.length > 2) {
            filter.all[0] = e.target.value;
            localStorage.setItem("trackFilter", JSON.stringify(filter));
            initFunc(1, filter);
          } else {
            localStorage.setItem("trackFilter", JSON.stringify(filter));
            initFunc(1, filter);
          }
        }, 1000)
        setIntervalId(newIntervalId);  ;
    
      };

      const sortClick = (e) => {
        setSortName(e.target.innerHTML);
        const currentIdIndex = sortOtions.findIndex(
          (x) => x.value === e.target.innerHTML
        );
        setSortData(sortOtions[currentIdIndex].id);
        let data = {};
        if (sortData === sortOtions[currentIdIndex].id && sortValue === "asc") {
          setSortValue("desc");
          data[sortOtions[currentIdIndex].id] = "desc";
        } else {
          data[sortOtions[currentIdIndex].id] = "asc";
          setSortValue("asc");
        }
        localStorage.setItem("trackSort", JSON.stringify(data));
        initFunc();
        setModal(false);
      };


      const  initFunc=(page = 1, filter) => {
        let data = {};
        if (filter) {
          data.filter = { ...filter };
        } else {
          if (localStorage.getItem("trackFilter")) {
            data.filter = { ...JSON.parse(localStorage.getItem("trackFilter")) };
          } else {
            data.filter = {};
          }
        }
        if (localStorage.getItem("trackSort")) {
          data.sort = { ...JSON.parse(localStorage.getItem("trackSort")) };
        } else {
          data.sort = { updatedAt: "desc" };
        }
    
    
        data.offset = (page - 1) * 10;
        data.limit = 10;
        dispatch(getTracks(data)).then((res) => {
          console.log(res);
          setReady(true);
        });
      };

      useEffect(() => {
        if (!ready) {
          if (localStorage.getItem("trackFilter")) {
            let filter = JSON.parse(localStorage.getItem("trackFilter"));
            initFunc(1, filter);
            setFilterArr(filter);
          } else {
            initFunc();
          }
        }
      }, [ready]);


      if (!ready) {
        return (
          <div style={{ position: "relative" }}>
            {" "}
            <div style={{ position: "absolute", top: "50%", left: "50%" }}>
              <Loader />
            </div>{" "}
          </div>
        );
      } else{
        return (
    <>
        <div className="headerWithButtonsCommonBlock">
          <div className="headerWithButtonsHeaderBlock">
            <h1>Бібліотека треків</h1>
          </div>
          <div className="headerWithButtonsButtonBlock">
            {searchOpen && (
              <div style={{ marginBottom: "4px" }} className="apInputText">
                <label htmlFor="search">Пошук</label>
                <input
                  id="search"
                  type="text"
                  placeholder="Мінімум 3 символи"
                  value={searchValue}
                  onChange={searchChange}
                />
              </div>
            )}
            <button
              className="secondaryButtonIconDefault"
              onClick={() => setSearchOpen(!searchOpen)}
            >
              <svg>
                <use href="/images/icon24Search.svg#icon24" />
              </svg>
            </button>
          </div>
        </div>
        <div className="pageContentHeaderDivider" />
        <div className="dictAllRowsContainer">
          {track &&
            track.items &&
            track.items.length > 0 ?
            track.items.map((el, index) => {
              return (
                <div key={index} className="catVideosRowNormal" 
                onClick={() => navigate(`/trackitem/${el.id}`)}
                >
                  <div className="catVideoValue" style={{zIndex:1}}>
                    <div
                      style={{ backgroundImage: `url("${el.screenshot|| el.coverImage}")` }}
                      className="myObjectValueImageCus"
                    />
                  </div>
                  <div
                    className="catVideoValue"
                  >
                    {el.name}
                  </div>
                  <div className="catVideoValue">
                    {listId.list[el.type]}
                    <span>{listId.list[el.complexityId]}</span>
                  </div>
                  <div className="catVideoValue specWidth">
                    {el.address}
                    <span>Адреса</span>
                  </div>
                
                  <div className="catVideoValue">
                    {getDate(el.updatedAt,'dd/mm/yyyy hh:mm', '.')}
                    <span>Змінено</span>
                  </div>
                  <div className="catVideoValue">
                    {el.isTrackActive == "1" && (
                      <div className="apPublished">Активний</div>
                    )}
                    {el.isTrackActive == "0" && (
                      <div className="apOnRepair">Не&nbsp;активний</div>
                    )}
                  </div>
                </div>
              );
            }):
            <div className="apFcEvent empty" style={{maxWidth:'100%'}}>
            Не створено жодного треку
            </div>
            }
          
        </div>
        {track.total > 10 && (
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={track.total.toFixed(0)}
            pageSize="10"
            onPageChange={async (page) => {
              await setCurrentPage(page);
              await initFunc(page);
            }}
          />
        )}
    
    </>
)}

}

export default TrackLibraryPage;